export default __webpack_public_path__ + "images/058cfa98d4943a141217a3fd8cb0a427.png";